import { render } from "./Shifts.vue?vue&type=template&id=6e49723e&scoped=true"
import script from "./Shifts.vue?vue&type=script&lang=js"
export * from "./Shifts.vue?vue&type=script&lang=js"

import "./Shifts.vue?vue&type=style&index=0&id=6e49723e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e49723e"]])

export default __exports__